export const locationEvents = {
  seeWorkplace: 'See workplace',
  editWorkplace: 'edit_workplace_start',
}

export const workAreasEvents = {
  addWorkAreaSubmit: 'Go to shift management create workarea submit',
}
